import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Row, Col, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { ApiService } from '../services/api';
import { ChangePasswordRequest } from '../types';

const { Title } = Typography;

const ChangePassword: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values: { old_password: string; new_password: string; confirm_password: string }) => {
        setLoading(true);

        try {
            const request: ChangePasswordRequest = {
                old_password: values.old_password,
                new_password: values.new_password
            };

            const response = await ApiService.changePassword(request);

            if (response.code === 200) {
                message.success(response.message || '密码修改成功');
                form.resetFields();
            } else {
                message.error(response.message || '密码修改失败');
            }
        } catch (error: any) {
            console.error('密码修改失败:', error);
            message.error(error.response?.data?.message || '密码修改失败，请重试');
        } finally {
            setLoading(false);
        }
    };

    const validateConfirmPassword = (_: any, value: string) => {
        if (!value || form.getFieldValue('new_password') === value) {
            return Promise.resolve();
        }
        return Promise.reject(new Error('两次输入的新密码不一致'));
    };

    return (
        <div style={{ padding: '24px' }}>
            <Row justify="center">
                <Col xs={24} sm={20} md={16} lg={12} xl={8}>
                    <Card
                        title={
                            <div style={{ textAlign: 'center' }}>
                                <LockOutlined style={{ marginRight: 8 }} />
                                <Title level={4} style={{ display: 'inline', margin: 0 }}>
                                    修改密码
                                </Title>
                            </div>
                        }
                        style={{ maxWidth: 500, margin: '0 auto' }}
                    >
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleSubmit}
                            autoComplete="off"
                        >
                            <Form.Item
                                label="当前密码"
                                name="old_password"
                                rules={[
                                    { required: true, message: '请输入当前密码' }
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="请输入当前密码"
                                    size="large"
                                />
                            </Form.Item>

                            <Form.Item
                                label="新密码"
                                name="new_password"
                                rules={[
                                    { required: true, message: '请输入新密码' },
                                    { min: 6, message: '密码长度至少6位' },
                                    { max: 100, message: '密码长度不能超过100位' }
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="请输入新密码（至少6位）"
                                    size="large"
                                />
                            </Form.Item>

                            <Form.Item
                                label="确认新密码"
                                name="confirm_password"
                                dependencies={['new_password']}
                                rules={[
                                    { required: true, message: '请确认新密码' },
                                    { validator: validateConfirmPassword }
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="请再次输入新密码"
                                    size="large"
                                />
                            </Form.Item>

                            <Form.Item style={{ marginBottom: 0 }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    size="large"
                                    block
                                >
                                    {loading ? '修改中...' : '修改密码'}
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ChangePassword; 